'use client';

import { SelectInput } from '@innovixx/react-form-fields';
import React from 'react';
import sharedStyles from '../sharedStyles/styles.module.scss';
import colors from '../../../styles/colors/index.module.scss';

type Props = React.ComponentProps<typeof SelectInput>

export const AppSelectInput: React.FC<Props> = ({ classNames, ...props }) => (
  <SelectInput
    classNames={{
      error: sharedStyles.errorMessage,
      ...classNames,
    }}
    styles={{
      valueContainer: (provided) => ({
        ...provided,
        padding: '0 10px',
      }),
      control: (provided, state) => ({
        ...provided,
        border: `1px solid ${colors.primary}`,
        borderRadius: '5px !important',
        minHeight: '52px',
        padding: '0 10px',
        cursor: 'pointer',
        ...(state.isFocused && {
          outline: `1px solid ${colors.secondary} !important`,
          outlineOffset: '2px',
        }),
      }),
      option: (provided) => ({
        ...provided,
        cursor: 'pointer',
        borderRadius: '5px !important',
      }),
      menu: (provided) => ({
        ...provided,
        borderRadius: '5px !important',
        padding: '0 5px',
        zIndex: 1000,
      }),
    }}
    {...props}
  />
);
